// extracted by mini-css-extract-plugin
export default {"input":"SummaryTable_input__c2mM0"};